<template>
<v-container>
  <v-layout row wrap>
    <v-flex xs12 sm12 md12>
      <template v-for="message in messages">
        <v-container :key="message.message_id" v-if="!activeMessage || activeMessage === message">
          <v-card>
            <v-card-title>
              <h3>{{ message.message_title }}</h3></v-card-title>
            <v-card-text class="grey lighten-5" v-html="message.message_body ? message.message_body.message_body : ''" style="overflow:auto">
            </v-card-text>
            <v-card-text v-if="!activeMessage" class="grey lighten-5">
              <v-btn v-if="message.replies.length" @click="activeMessage = message" flat>{{ message.replies.length }} Antworten</v-btn>
              <v-btn color="blue" fab dark small absolute bottom right>
                <v-icon>menu</v-icon>
              </v-btn>
            </v-card-text>
          </v-card>
        </v-container>
      </template>
      <template v-if="activeMessage">
        <v-container v-for="msg in activeMessage.replies" :key="msg.message_id">
          <v-card>
            <v-card-title>
              <h3>{{ msg.message_title }}</h3>
            </v-card-title>
            <v-card-text class="grey lighten-5" v-html="msg.message_body ? msg.message_body.message_body : ''" style="overflow:auto">
            </v-card-text>
          </v-card>
        </v-container>
      </template>
      <v-container>
        <v-card>
          <v-card-title>
            <h3>{{ activeMessage ? 'Antwort' : 'Nachricht' }} verfassen</h3>
          </v-card-title>
          <v-card-text>
            <v-text-field placeholder='Betreff' v-model="title"></v-text-field>
          </v-card-text>
          <v-card-text class="grey lighten-5">
            <vue-editor v-model="text" :editorToolbar="customToolbar"></vue-editor>
          </v-card-text>
          <v-card-text class="grey lighten-5">
            <v-btn color="blue" fab dark small absolute bottom right @click="sendMessage">
              <v-icon>send</v-icon>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-container>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import {
  VueEditor
} from 'vue2-editor'

export default {
  components: {
    VueEditor
  },
  data() {
    return {
      hidden: false,
      messages: [],
      activeMessage: false,
      title: '',
      text: '',
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [{
          'list': 'ordered'
        }, {
          'list': 'bullet'
        }],
        ['image', 'code-block']
      ]
    }
  },
  created() {
    this.$api.communication.findMessage().then((response) => {
      this.messages = response.data.filter((element, index, array) => {
        if (element.parent_message_id !== 0) return false
        element.replies = array.filter((msg, i, a) => {
          return msg.parent_message_id === element.message_id
        })
        return true
      })
      this.$nextTick(() => {
        this.scrollToEnd()
      })
    })
  },
  methods: {
    sendMessage() {
      this.$api.communication.postMessage({
        message_title: this.title,
        message_body: {
          message_body: this.text
        }
      }).then((response) => {
        this.messages.push(response.data)
        this.title = this.text = ''
        this.$nextTick(() => {
          this.scrollToEnd()
        })
      })
    },
    scrollToEnd() {
      var container = document.getElementsByTagName('html')[0]
      container.scrollTop = container.scrollHeight
    }
  }
}
</script>



// WEBPACK FOOTER //
// Messages.vue?419b136e